<template>
  <v-tooltip right>
    <template slot="activator">
      <div
        slot="activator"
        @click="routerPush('/loginlp/report')"
        class="change-advertiser"
        flat
      >
        <div class="img-text-wrapper">
          <img
            class="change-advertiser-icon"
            src="@/assets/images/swap-horizontal-circle.svg"
            alt=""
          />
          <span class="text-under-img">広告主の変更</span>
        </div>
      </div>
    </template>
    <span>広告主の変更</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'ChangeAdvertiserButton',
  methods: {
    routerPush(path) {
      this.$router.push({ path }).catch(() => {})
    },
  },
}
</script>

<style scoped lang="scss">
.change-advertiser {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.text-under-img {
  margin-left: -20px;
  font-size: 10px;
  display: block;
}

.img-text-wrapper {
  margin-left: 15px;
  margin-top: 15px;
  text-align: center;
  display: block;
  background-color: transparent;
  border: 1px solid transparent;
}

.change-advertiser-icon {
  margin-left: -20px;
  width: 28px;
  height: 28px;
  transition: background-color 0.2s;
  cursor: pointer;
  border-radius: 10px;
  &:hover {
    background: #eaeaea;
  }
}
</style>
